module.exports = __webpack_public_path__ + "static/media/screen 4.cad64d01.png";